import React from "react";
import { FormattedMessage } from "react-intl";
import globalMessages from "../../../intl/globalMessages";
import GeneralTranslations from "../../../Common/ModuleTranslations/en";

export default {
  locale: "en",
  name: "Forms",
  translation: { displayName: "Translations" },
  fields: {
    /** Here are te entities used in the lists, Order is important */
    /** fieldName: this is used like the id container of the properties */
    /** displayName: this is the title rendered */
    list: [
      ...GeneralTranslations.fields.list,
      {
        fieldName: "active",
        widget: "singleSwitch",
        toggleAction: true,
        displayName: "Active",
      },
      {
        fieldName: "dependers",
        searchCriteria: "type",
        fieldSelector: {
          EXTRA: "Extra",
          GUEST_FORM: "Guest Form",
          CANCELLATION_FORM: "Cancellation Popup",
          ROOMSTAY_CHECKOUT: "Check-out form",
        },
        displayName: "Enable for",
      },
    ],
    /** Here is the entity used in the forms, Order is important */
    /** all the properties can be found in app/components/CRUD/Common, at the corresponding js file */
    /** fieldName: is like the id in html, it must be unique among the attributes */
    /** widget: is used to render the kind of interaction the user will have, a complete list can be found in component/CRUD/Common */
    /** displayName: The text that introduces the widget */
    /** defaultValue: The default value of the widget */
    /** optionDisplay: An object that containes objects with the option at the select */
    form: [
      ...GeneralTranslations.fields.form,
      {
        fieldName: "id",
        widget: "hidden",
      },
      {
        fieldName: "propertyTicker",
        widget: "hidden",
      },
      {
        fieldName: "active",
        displayName: "Active",
        widget: "singleSwitch",
        className: "activeCheckbox",
      },
      {
        fieldName: "dependers",
        displayName: "Enable for:",
        widget: "selector",
        optionDisplay: {
          EXTRA: {
            label: "Extras",
          },
          GUEST_FORM: {
            label: "Guest form",
          },
          CANCELLATION_FORM: {
            label: "Cancellation modal",
          },
          ROOMSTAY_CHECKOUT: {
            label: "Check-out: RoomStay",
          },
        },
        defaultValue: "EXTRA",
      },
      {
        fieldName: "dependersBoxes",
        widget: "multicheckbox",
        selectables: true,
        selectAllText: <FormattedMessage {...globalMessages.selectAll} />,
        selectNoneText: "Select none",
        visible: ({ formValues }) => {
          return formValues.dependers === "EXTRA";
        },
      },
      {
        /** In nested entities the fieldName must be used in the form so it knows which entities must be declared respectively. No need to put in the router the components*/
        fieldName: "fields",
        displayName: "Questions",
        introductionText: "The order of the questions will be reflected in the form",
        widget: "nestedEntity",
        nestedTitle: "Edit",
        nested: true,
        entityName: "CancellationPolicyConfiguration",
        defaultValue: [],
      },
    ],
  },
};
